import { render, staticRenderFns } from "./DashboardStatsCard.vue?vue&type=template&id=19912331&scoped=true"
import script from "./DashboardStatsCard.vue?vue&type=script&lang=js"
export * from "./DashboardStatsCard.vue?vue&type=script&lang=js"
import style0 from "./DashboardStatsCard.vue?vue&type=style&index=0&id=19912331&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19912331",
  null
  
)

export default component.exports